import React from 'react';
import { isString } from 'lodash';
import { toast } from 'react-toastify';

import firebase from '../firebase';
import { canUpdateProductHeadline } from '../shared/abilities';
import ModelFormModal from './modals/ModelFormModal';
import AddInTenantButton from './AddInTenantButton';
import EditButton from './EditButton';
import DeleteButton from './DeleteButton';
import { fields as productHeadlineFields } from '../shared/models/productHeadline';

const storageRef = firebase.storage().ref();
const db = firebase.firestore();
const productsRef = db.collection('products');
const productHeadlinesRef = db.collection('productHeadlines');

const processValues = async (values) => {
  const { id, image } = values;
  if (image == null) return values;

  const imageRef = storageRef.child(`productHeadlines/${id}/image`);
  let imageUrl;
  if (isString(image)) {
    imageUrl = image;
  } else {
    await imageRef.put(image, { contentType: image.type });
    imageUrl = await imageRef.getDownloadURL();
  }
  return { ...values, image: imageUrl };
};

export default function ProductHeadlines(props) {
  const { user, productHeadlines = [] } = props;
  return (
    <div>
      <div className="d-flex justify-content-end mb-3">
        <AddInTenantButton
          itemRef={productHeadlinesRef.doc()}
          processValues={processValues}
          FormModal={ModelFormModal}
          formProps={{ title: '商品見出し追加', fields: productHeadlineFields }}
          disabled={!canUpdateProductHeadline(user)}
        />
      </div>
      <table className="table">
        <thead className="thead-light text-center">
          <tr>
            <th>名称</th>
            <th>画像</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {productHeadlines.map((productHeadline) => {
            const { id, ref, name, image } = productHeadline;
            const beforeDelete = async () => {
              if (
                (await productsRef.where('productHeadlineId', '==', id).limit(1).get()).docs.length > 0
              ) {
                toast.error('使用されているため削除できません');
                return false;
              }
            };

            return (
              <tr key={id}>
                <td>{name}</td>
                <td>
                  {image && <img src={image} style={{ maxHeight: 60 }} />}
                </td>
                <td className="text-nowrap text-right">
                  <EditButton
                    itemRef={ref}
                    FormModal={ModelFormModal}
                    formProps={{ title: '商品見出し編集', fields: productHeadlineFields }}
                    disabled={!canUpdateProductHeadline(user)}
                    beforeSubmit={processValues}
                  />
                  <DeleteButton itemRef={ref} className="ml-2" disabled={!canUpdateProductHeadline(user)} beforeDelete={beforeDelete} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
